import { render, staticRenderFns } from "./SoilTextureCharacteristics.vue?vue&type=template&id=c01853be"
import script from "./SoilTextureCharacteristics.vue?vue&type=script&lang=js"
export * from "./SoilTextureCharacteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports